import { gql } from '@apollo/client';

/**
 * Catálogo de plantillas de recorrido del tenant.
 *
 * `onlyActive: true` es lo que pide el asistente; Gestión las quiere todas para
 * poder reactivar una.
 *
 * ⚠️ El `operationName` es contrato con los mocks E2E — no cambiarlo.
 */
export const GET_SURVEILLANCE_ROUTE_PRESETS = gql`
  query GetSurveillanceRoutePresets($onlyActive: Boolean) {
    surveillanceRoutePresets(onlyActive: $onlyActive) {
      id
      name
      isActive
      roadIDs
      roadRanges {
        roadId
        pkInitKm
        pkInitMeter
        pkEndKm
        pkEndMeter
      }
    }
  }
`;
